import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerWrapper: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(0),
      backgroundColor: '#ffa8c3',
    },
    topContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start', // Links ausrichten für Desktop-Ansicht
      [theme.breakpoints.down('sm')]: { // Wende Styles für Mobilgeräte an
        justifyContent: 'center' // Zentrieren auf Mobilgeräten
      }
    },
    logoLink: {
      display: 'inline-flex',
      alignItems: 'center',
      maxWidth: 'min(390px, 72vw)',
      '& span': {
        maxWidth: '100% !important',
      },
      '& img': {
        width: '100% !important',
        height: 'auto !important',
        maxHeight: 78,
        objectFit: 'contain',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: 'min(320px, 78vw)',
      },
    },
  })
);

export default useStyles;
